import { ContentLayoutF } from '@betterment/samba-react';
import { ErrorBoundary } from '@betterment/shared-components';
import { useRequiredParam } from '@betterment/shared-components/src/hooks/useRequiredParam';

import { ActivityCard } from './components/activity-card/ActivityCard';
import { PrimaryContentCard } from './components/content-card/PrimaryContentCard';
import { SecondaryContentCard } from './components/content-card/SecondaryContentCard';
import { CoordinatedAccountsCard } from './components/coordinated-accounts-card/CoordinatedAccountsCard';
import { CryptoAssetsRecommendationCard } from './components/crypto-assets-recommendation-card/CryptoAssetsRecommendationCard';
import { FourOhOneKContributionsCard } from './components/four-oh-one-k-contributions-card/FourOhOneKContributionsCard';
import { HoldingsCard } from './components/holdings-card/HoldingsCard';
import InvestableAssetsCard from './components/investable-assets-card/InvestableAssetsCard';
import { IraContributionsCard } from './components/ira-contributions-card/IraContributionsCard';
import { OverviewCard } from './components/overview-card/OverviewCard';
import { PendingOrdersCard } from './components/pending-orders-card/PendingOrdersCard';
import { PortfolioStrategyCard } from './components/portfolio-strategy-card/PortfolioStrategyCard';
import { RecurringTransactionsCard } from './components/recurring-transactions-card/RecurringTransactionsCard';
import { SecuritySearchCard } from './components/security-search-card/SecuritySearchCard';
import { TransferDepositCard } from './components/transfer-deposit-card/TransferDepositCard';

import { ApplicationLayout } from '../Shared/layout/ApplicationLayout';

export const AccountPage: React.FC = () => {
  const accountId = useRequiredParam('accountId');

  return (
    <ErrorBoundary fallbackType="full" feature="account_page" owner="user_engagement">
      <ApplicationLayout pageTitle={null} feature="account_page">
        <ApplicationLayout.Content>
          <ContentLayoutF
            css={{
              paddingTop: 'space.400',
              display: 'flex',
              justifyContent: 'center',
            }}
          >
            <ContentLayoutF.SlotContainer css={{ maxWidth: '1200px', flex: 1 }}>
              <ContentLayoutF.Slot1
                css={{ display: 'grid', gap: { base: 'space.100', sm: 'space.300' }, gridAutoRows: 'max-content' }}
              >
                <PrimaryContentCard />
                <OverviewCard />
                <CoordinatedAccountsCard />
                <PortfolioStrategyCard />
                <PendingOrdersCard />
                <HoldingsCard />
                <ActivityCard />
              </ContentLayoutF.Slot1>
              <ContentLayoutF.Slot2
                css={{ display: 'grid', gap: { base: 'space.100', sm: 'space.300' }, gridAutoRows: 'max-content' }}
              >
                <SecuritySearchCard />
                <TransferDepositCard />
                <InvestableAssetsCard accountId={accountId} />
                <RecurringTransactionsCard />
                <CryptoAssetsRecommendationCard />
                <FourOhOneKContributionsCard />
                <IraContributionsCard />
                <SecondaryContentCard />
              </ContentLayoutF.Slot2>
            </ContentLayoutF.SlotContainer>
          </ContentLayoutF>
        </ApplicationLayout.Content>
      </ApplicationLayout>
    </ErrorBoundary>
  );
};
